import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { Button } from 'src/core/ui/Button';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './DataInsightsChart.css';

export type ChartType = 'revenue' | 'pnl' | 'marketshare' | 'sales'; // Define a type for chart types

export const ChartTypeSelector = ({
  chartType,
  setChartType,
}: {
  chartType: ChartType;
  setChartType: React.Dispatch<React.SetStateAction<ChartType>>;
}) => {
  return (
    <Stack style={{ justifyContent: 'flex-end' }}>
      <Button
        variant={chartType === 'pnl' ? 'rectangle' : 'textPlain'}
        onClick={() => setChartType('pnl')}
        className={styles.chartSelectorButton}
      >
        <Content id={ContentId.ProfitNLoss} />
      </Button>
      <Button
        variant={chartType === 'revenue' ? 'rectangle' : 'textPlain'}
        onClick={() => setChartType('revenue')}
        className={styles.chartSelectorButton}
      >
        <Content id={ContentId.Revenue} />
      </Button>
      <Button
        variant={chartType === 'sales' ? 'rectangle' : 'textPlain'}
        onClick={() => setChartType('sales')}
        className={styles.chartSelectorButton}
      >
        <Content id={ContentId.Sales} />
      </Button>
      <Button
        variant={chartType === 'marketshare' ? 'rectangle' : 'textPlain'}
        onClick={() => setChartType('marketshare')}
        className={styles.chartSelectorButton}
      >
        <Content id={ContentId.MarketShare} />
      </Button>
    </Stack>
  );
};
